import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import EditUserGroupForm from '../../../../components/admin/usergroups/edit/usergroup-edit-form';
import BackLink from '../../../../components/common/back-link/index';
import PageTitle from '../../../../components/common/page-title/index';
import { getUserGroup } from '../../../../actions/usergroups';

import './styles.css';

class EditUserGroup extends Component {
  UNSAFE_componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getUserGroup(this.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_usergroup'));
    this.props.dispatch({ type: 'CLEAR_EDIT_USERGROUP' });
  }

  render() {
    return (
      <Container fluid className="usergroups">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/user-groups"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Add/Edit usergroup
            </PageTitle>
          </Col>
        </Row>
        <EditUserGroupForm
          userGroup={this.props.userGroup}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  userGroup: state.userGroups.userGroup,
  fetched: state.userGroups.fetched,
  fetching: state.userGroups.fetching,
});

export default connect(mapStateToProps)(EditUserGroup);
